<template>
  <div class="pda-default" v-if="surveyData">
    <div class="mdc-card mdc-elevation--z3 pda-default">
      <div class="t-subtitle2">
        {{ $t("698") }}
        <!-- 설문 참여 포인트 -->
      </div>
      <div class="mgt-16 t-body1">
        <div
          class="d-flex flex-row justify-content-between align-items-center mgt-16 mgb-16"
        >
          <img src="@/assets/icon_point.svg" alt="" class="icon" />
          <span class="flex-grow-1 mgr-16 mgl-16 t-color-bodyGrayA">
            {{ $t("699") }}
            <!-- 설문 완료 포인트 -->
          </span>
          <span>
            {{ $t("701", { str: $n(surveyData.point.closeEarnPoint) }) }}
          </span>
        </div>

        <div
          class="d-flex flex-row justify-content-between align-items-center mgt-16 mgb-16"
        >
          <img src="@/assets/icon_point.svg" alt="" class="icon" />
          <span class="flex-grow-1 mgr-16 mgl-16 t-color-bodyGrayA  ">
            {{ $t("700") }}
            <!-- 전 문항 응답 포인트 -->
          </span>
          <span>
            {{ $t("701", { str: $n(surveyData.point.responseAllEarnPoint) }) }}
          </span>
        </div>
      </div>
    </div>

    <div
      class="mdc-card mdc-elevation--z3 mgt-16 pda-default"
      v-if="badgesData.length"
    >
      <div class="t-subtitle2">
        {{ $t("1015") }}
        <!-- 배지 -->
      </div>
      <div class="mgt-6">
        <div
          class="d-flex flex-row justify-content-between align-items-center mgt-16 mgb-16"
          v-for="(badge, index) in badgesData"
          :key="index"
        >
          <div v-if="badge.image">
            <img :src="badge.image" alt="" class="badge" />
          </div>
          <span class="flex-grow-1 mgr-16 mgl-16">
            {{ badge.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["surveyData", "badgesData"],
};
</script>

<style>
</style>